<template>
  <div>
    <b-card>
      <b-row class="px-1 align-items-center justify-content-between">
        <h5> الأموال المُحولة للخارج</h5>
        <div v-can="{ slug: $route.meta.instructionsSlug, action: 'C' }">
          <!-- <b-button
            variant="success d-flex align-items-center"
            @click="financialGrantModal = true "
          >
            <feather-icon size="18" icon="PlusIcon" />
            <span class="mx-25"> إضافة </span>
          </b-button> -->
        </div>
      </b-row>
      <hr />
      
    <data-table
      ep="v2/money-transferred-abroad"
      id="MoneyTransferredAbroad"
      :fields="fields"
      striped
      ref="MoneyTransferredAbroadTable"
    >
      <template #cell(file)="{ value }" >
        <b-button
          size="sm"
          @click="$router.push({ name: 'file-view', query: { ep: value } })"
          variant="flat-success"
        >
          <feather-icon class="mx-25" icon="EyeIcon" />
          عرض الملف
        </b-button>
      </template>

      <!-- <template #cell(_)="row">
        <div class="d-flex align-items-center justify-content-end">
          <b-button
            variant="flat-info"
            @click="row.toggleDetails"
            title="عرض المزيد من المعلومات"
            size="sm"
            class="btn-icon rounded-circle"
            v-b-tooltip.hover.v-info.top
          >
            <feather-icon icon="InfoIcon" size="1.8x" color="#82868b" />
          </b-button>
         
        </div>
      </template>
      <template #row-details="row">
        <b-card>
          <b-row class="mb-2">
            <b-col md="12" class="mb-1 d-flex">
              <strong>أوجه الإنفاق المُراد توظيف الإعانة فيها :</strong>
              <div class="text-info mx-1" v-html="row.item.expenditures"></div>
            </b-col>
          </b-row>

          <b-button
            size="sm"
            variant="outline-secondary"
            @click="row.toggleDetails"
          >
            عرض اقل
          </b-button>
        </b-card>
      </template> -->
    </data-table>

    </b-card>
  </div>
</template>

<script>
import { BCard, BRow, BCol, BFormFile, BButton , BDropdown, BDropdownItem, VBTooltip } from "bootstrap-vue";
import DataTable from "@/components/data-table";
import Ripple from "vue-ripple-directive";
export default {
  components: {
    DataTable,
    BCard,
    BRow,
    BCol,
    BFormFile,
    BButton,
    BDropdown, BDropdownItem, VBTooltip
  },
  directives: {
    "b-tooltip": VBTooltip,
    Ripple,
  },
  data() {
    return {
      fields: [
        {
          key: "id",
          label: "المعرف",
        },
        {
          key: "amount",
          label: "المبلغ الذي تمّ تحويله",
        },
        {
          key: "reason",
          label: "سبب التحويل",
        },
        {
          key: "file",
          label: "الكتاب الخطي",
        },
        "_",
      ],
    };
  },
};
</script>
